import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersService } from './services/users.service';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { LogsComponent } from './pages/logs/logs.component';
import { AutomationComponent } from './pages/automation/automation.component';
import { UserComponent } from './components/user/user.component';
import { UserTableComponent } from './components/user-table/user-table.component';
import { UserDialogComponent } from './components/user-dialog/user-dialog.component';
import { GroupManagerComponent } from './components/group-manager/group-manager.component';
import { TabComponent } from './components/tab/tab.component';
import { TabTableComponent } from './components/tab-table/tab-table.component';
import { TabManagerComponent } from './components/tab-manager/tab-manager.component';
import { SetupComponent } from './pages/setup/setup.component';
import { ColumnComponent } from './components/column/column.component';
import { DropdownentryComponent } from './components/dropdownentry/dropdownentry.component';
import { NoteComponent } from './components/note/note.component';
import { TableprofileComponent } from './components/tableprofile/tableprofile.component';
import { SelectListComponent } from './components/select-list/select-list.component';

@NgModule({
  declarations: [
    AdminComponent,
    DashboardComponent,
    UserManagementComponent,
    LogsComponent,
    AutomationComponent,
    UserComponent,
    UserTableComponent,
    UserDialogComponent,
    GroupManagerComponent,
    TabComponent,
    TabTableComponent,
    TabManagerComponent,
    SetupComponent,
    ColumnComponent,
    DropdownentryComponent,
    NoteComponent,
    TableprofileComponent,
    SelectListComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    MatExpansionModule,
    MatCheckboxModule
  ],
  providers: [UsersService],
  entryComponents: [UserDialogComponent]
})
export class AdminModule { }
